import { reactive } from 'vue';
import { IFileUpload } from '@/types/interfaces';

export interface IUploadInfo {
  counter: number,
  success: number,
  error: number,
  canBeSuccess: number,
  total: number,
  totalBytesSize: number,
  totalBytesUploaded: number,
  id?: string
}

export interface IOnUploadUpdate {
  addSuccess: () => void,
  addError: () => void,
  clear: () => void,
  getUploadInfo: () => IUploadInfo
  isUploadFinished: () => boolean
  setStartInfo: (fileUpload: IFileUpload[]) => void
}

export interface IUseUpload {
  onUploadUpdate: () => IOnUploadUpdate
  uploadInfo: IUploadInfo
}

export default function UseUpload(): IUseUpload {
  const uploadInfo = reactive<IUploadInfo>({
    counter: 0,
    success: 0,
    error: 0,
    canBeSuccess: 0,
    total: 0,
    totalBytesSize: 0,
    totalBytesUploaded: 0,
  });

  function onUploadUpdate(): IOnUploadUpdate {
    const addSuccess = () => {
      uploadInfo.counter += 1;
      uploadInfo.success += 1;
    };

    const addError = () => {
      uploadInfo.counter += 1;
      uploadInfo.error += 1;
      uploadInfo.canBeSuccess -= 1;
    };

    const clear = () => {
      uploadInfo.counter = 0;
      uploadInfo.error = 0;
      uploadInfo.success = 0;
      uploadInfo.canBeSuccess = 0;
      uploadInfo.total = 0;
      uploadInfo.totalBytesSize = 0;
      uploadInfo.totalBytesUploaded = 0;
    };

    const setStartInfo = (fileUpload: IFileUpload[]) => {
      onUploadUpdate().clear();
      uploadInfo.canBeSuccess = fileUpload.length;
      uploadInfo.total = fileUpload.length;

      uploadInfo.totalBytesSize = fileUpload.reduce((prev, current) => prev + current.file.size, 0);
    };

    const getUploadInfo = () => uploadInfo;

    const isUploadFinished = () => uploadInfo.canBeSuccess === uploadInfo.success;

    return {
      addSuccess,
      addError,
      clear,
      getUploadInfo,
      isUploadFinished,
      setStartInfo,
    };
  }

  return {
    onUploadUpdate,
    uploadInfo,
  };
}
